import React from 'react'

import { CheckboxGroup } from '../checkbox-group/CheckboxGroup'
import { Tree } from '../tree/Tree'

type CheckboxTreeCollapsibleContentProps = Omit<
  React.ComponentProps<typeof Tree.CollapsibleContent>,
  'asChild'
>

export const CheckboxTreeCollapsibleContent = ({
  children,
  ...rest
}: CheckboxTreeCollapsibleContentProps): React.JSX.Element => {
  return (
    <CheckboxGroup.Sub asChild>
      <Tree.CollapsibleContent {...rest} forceMount>
        {children}
      </Tree.CollapsibleContent>
    </CheckboxGroup.Sub>
  )
}
